import React, { forwardRef } from 'react';
import { track } from '../modules/tracking';
import PropTypes from 'prop-types';
import {
    CELERY,
    CRUSTACEAN,
    EGG,
    FISH,
    GLUTEN,
    LUPIN,
    MILK,
    MOLLUSC,
    MUSTARD,
    NUT,
    PEANUT,
    SESAME,
    SOYA,
    SULPHITE,
    ALMONDS,
    HAZELNUTS,
    WALNUTS,
    BRAZIL_NUTS,
    CASHEWS,
    PECANS,
    PISTACHIOS,
    MACADAMIA_NUTS,
    TRACE,
    ALLERGEN_TAB
} from '../modules/constants';

import { Toggle } from '.';

/**
 * allergenLabelToKebabCase - converts a string to kebab-case
 * e.g 'Macadamia nuts' => 'macadamia-nuts'
 * @param {String} str the string to convert
 * @returns String
 */
export function allergenLabelToKebabCase(str) {
    return str.replace(' ', '-').toLowerCase();
}
/**
 * allergenLabelToConstantName - converts a string to a constant name
 * e.g 'Macadamia nuts' => 'MACADAMIA_NUTS'
 * @param {String} str the string to convert
 * @returns String
 */
export function allergenLabelToConstantName(str) {
    return str.replace(/-/g, '_').replace(/ /g, '_').toUpperCase();
}

/**
 * AllergenFilter - child filter component which allows filtering of the results on the page by allergen.
 *
 * @function
 * @param    {object} props the properties for this filter.
 * @param    {object} ref   Ref forwarded from the parent filter component.
 * @returns  {HTMLElement}       Form allowing choosing of allergens to filter out.
 */
const AllergenFilter = forwardRef(function allergeFilterRef(props, ref) {
    const { allergenFilter, setAllergenFilter } = props;

    function collectAllergenFilterData(e) {
        const elem = e.target;
        const update = {};
        const allergenType = allergenLabelToConstantName(elem.name);
        update[allergenType] = elem.checked;
        track(
            `Filters: Click: Allergen: ${elem.name} ${
                elem.checked ? 'filter on' : 'filter off'
            }`
        )();

        setAllergenFilter({
            ...allergenFilter,
            ...update
        });
    }

    const allergenFilterData = [
        CELERY,
        CRUSTACEAN,
        EGG,
        FISH,
        GLUTEN,
        LUPIN,
        MILK,
        MOLLUSC,
        MUSTARD,
        SESAME,
        SOYA,
        SULPHITE,
        NUT,
        PEANUT,
        ALMONDS,
        HAZELNUTS,
        WALNUTS,
        BRAZIL_NUTS,
        CASHEWS,
        PECANS,
        PISTACHIOS,
        MACADAMIA_NUTS
    ];

    return (
        <div className={props.blockClass}>
            <p>{ALLERGEN_TAB}</p>

            <form ref={ref} onChange={collectAllergenFilterData.bind(this)}>
                <label className='trace' htmlFor='trace'>
                    <input
                        id='trace'
                        name='hideTraces'
                        type='checkbox'
                        defaultChecked={allergenFilter.HIDETRACES}
                    />
                    <Toggle type='yn' />
                    {TRACE}
                </label>
                {allergenFilterData.map((allergen) => {
                    const allergenKebabCaseName =
                        allergenLabelToKebabCase(allergen);
                    const allergenConstantName =
                        allergenLabelToConstantName(allergen);
                    return (
                        <span key={allergenKebabCaseName}>
                            <input
                                id={allergenKebabCaseName}
                                name={allergenKebabCaseName}
                                type='checkbox'
                                value={allergenKebabCaseName}
                                defaultChecked={
                                    allergenFilter[allergenConstantName]
                                }
                            />
                            <label htmlFor={allergenKebabCaseName}>
                                {allergen}
                            </label>
                        </span>
                    );
                })}
            </form>
        </div>
    );
});

AllergenFilter.propTypes = {
    showTrace: PropTypes.bool,
    allergenFilter: PropTypes.object,
    showAllergenFilter: PropTypes.bool,
    setAllergenFilter: PropTypes.func,
    setShowAllergenFilter: PropTypes.func,
    blockClass: PropTypes.string
};

export { AllergenFilter };
